module.exports = __webpack_public_path__ + "static/images/hero.eae03962431e0e3078143bc78a916b10.jpg";